const columns: TableColumn[] = [
  {
    Header: `Office ID`,
    accessor: `officeId`,
    dbKey: `officeId`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Zoopla Branch ID`,
    accessor: `zooplaBranchId`,
    dbKey: `zooplaBranchId`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Location`,
    accessor: `location`,
    dbKey: `location`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Branch`,
    accessor: `type`,
    dbKey: `type`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Origin`,
    accessor: `origin`,
    dbKey: `origin`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Source`,
    accessor: `source`,
    dbKey: `source`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Introducer Name`,
    accessor: `introducerName`,
    dbKey: `introducerName`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Introducer ID`,
    accessor: `introducerId`,
    dbKey: `introducerId`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Introducer Branch Name`,
    accessor: `introducerBranchName`,
    dbKey: `introducerBranchName`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Introducer Branch ID`,
    accessor: `introducerBranchId`,
    dbKey: `introducerBranchId`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Appointment Notification Email`,
    accessor: `appointmentNotificationEmail`,
    dbKey: `appointmentNotificationEmail`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Everglades API Key`,
    accessor: `evergladesApiKey`,
    dbKey: `evergladesApiKey`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: `Branch Email`,
    accessor: `branchEmail`,
    dbKey: `branchEmail`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Read Email`,
    accessor: `readEmail`,
    dbKey: `readEmail`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Robot Email`,
    accessor: `robotEmail`,
    dbKey: `robotEmail`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Mortgage Email`,
    accessor: `mortgageEmail`,
    dbKey: `mortgageEmail`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Valuation Email`,
    accessor: `valuationEmail`,
    dbKey: `valuationEmail`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Phone`,
    accessor: `phone`,
    dbKey: `phone`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Supplier Number`,
    accessor: `supplierNumber`,
    dbKey: `supplierNumber`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: true
  },
  {
    Header: `Postal Codes`,
    accessor: `postalCodes`,
    dbKey: `postalCodes`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  },
  {
    Header: ``,
    accessor: `action`,
    dbKey: `action`,
    isString: true,
    isNumeric: false,
    isDate: false,
    isBool: false,
    isSortable: false
  }
];

export default columns;
